import { FUTURO } from '../../../foundations/color';
import { standard } from './standard';

export const futuro = {
  ...standard,
  height: {
    large: '3.5rem',
    medium: '3rem',
    default: '3rem',
  },
  tooltip: {
    bg: FUTURO.LIGHT.STORM,
    text: FUTURO.LIGHT.SWAN,
  },
  error: {
    text: FUTURO.LIGHT.ROSE,
  },
  boxShadow: {
    active: 'none',
    inActive: 'none',
    error: 'none',
  },
  borderRadius: '4px',
  background: {
    active: FUTURO.LIGHT.WHITE,
    inActive: FUTURO.LIGHT.SMOKE,
    error: FUTURO.LIGHT.WHITE,
  },
  border: {
    active: `2px solid ${FUTURO.LIGHT.SLATE}`,
    inActive: `2px solid ${FUTURO.LIGHT.STONE}`,
    error: `2px solid ${FUTURO.LIGHT.ROSE}`,
  },
  color: {
    active: FUTURO.LIGHT.STORM,
    inActive: FUTURO.LIGHT.STORM,
    error: FUTURO.LIGHT.STORM,
  },
  labelColor: {
    active: FUTURO.LIGHT.SPACE,
    inActive: FUTURO.LIGHT.STEEL,
    error: FUTURO.LIGHT.SPACE,
  },
  hintColor: {
    active: FUTURO.LIGHT.STEEL,
    inActive: FUTURO.LIGHT.SHADOW,
    error: FUTURO.LIGHT.STEEL,
  },
  errorLabelColor: {
    error: FUTURO.LIGHT.ROSE,
  },
  extras: {
    ...standard.extras,
    [`&:focus`]: {
      outline: 'none',
      border: `2px solid ${FUTURO.LIGHT.SPACE}`,
      outlineOffset: '',
    },
    [`::-webkit-outer-spin-button, ::-webkit-inner-spin-button`]: {
      WebkitAppearance: 'none',
      margin: 0,
      background: 'inherit',
      cursor: 'inherit',
      color: 'inherit',
      backgroundColor: 'inherit',
    },
  },
};
